import z from "zod";

export const sexEnum = z.enum(["male", "female", "transgender", "other"]);